module.exports = __webpack_public_path__ + "img/proverb02.96d5d95e.png";